import React, { type ReactNode } from 'react';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import InfoIcon from '@atlaskit/icon/core/status-information';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import { Inline, xcss } from '@atlaskit/primitives';

type Appearance = 'info' | 'warning' | 'error';

export const AlertMessage = ({
	appearance,
	children,
	testId,
}: {
	appearance: Appearance;
	children: ReactNode;
	testId: string;
}) => {
	const StyleConfig = getIconAndStyles(appearance);
	return (
		<Inline alignBlock="center" testId={testId} space="space.050" xcss={StyleConfig.styles}>
			<StyleConfig.Icon color="currentColor" spacing="spacious" label="" />
			<span>{children}</span>
		</Inline>
	);
};

const infoStyles = xcss({ color: 'color.text.subtle' });
const warningStyles = xcss({ color: 'color.text.warning' });
const errorStyles = xcss({ color: 'color.text.danger' });

const getIconAndStyles = (appearence: Appearance) => {
	switch (appearence) {
		case 'info':
			return { Icon: InfoIcon, styles: infoStyles };
		case 'warning':
			return { Icon: WarningIcon, styles: warningStyles };
		case 'error':
			return { Icon: ErrorIcon, styles: errorStyles };
		default:
			return { Icon: InfoIcon, styles: infoStyles };
	}
};
